import React, {FC} from 'react';
import styled from 'styled-components';

import {EventHandler, Renderer} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledErrorButton = styled(ChromelessButton)`
  grid-area: right;
  align-self: center;
`;

/*
 * Component.
 */

export interface NavigationLineErrorIconProps {
  onClick?: EventHandler;
  isLowlighted?: boolean;
  renderTooltip?: Renderer;
}

export const NavigationLineErrorIcon: FC<NavigationLineErrorIconProps> = (props) => {
  const theme = useUserTheme();
  const defaultColor = props.isLowlighted ? theme.palette.grey.shade30 : theme.palette.orange.shade40;
  const hoverColor = props.isLowlighted ? theme.palette.grey.shade40 : theme.palette.orange.shade50;

  return (
    <StyledErrorButton onClick={props.onClick}>
      <TooltipCoordinator render={props.renderTooltip} placement="right">
        <Icon name="warningFilledSmall" color={defaultColor} hoverColor={props.onClick && hoverColor} />
      </TooltipCoordinator>
    </StyledErrorButton>
  );
};
